<template>
  <div class="Profile__General__Page">
    <div class="Profile__General__Page__Header">
      <h1>מסמכי הסבה לפי עיריה</h1>
    </div>
    <div class="Profile__General__Page__Form">
      <ProfileMunicipalityTransferDocuments />
    </div>
  </div>
</template>

<script>
import ProfileMunicipalityTransferDocuments from "@/components/ProfileMunicipalityTransferDocuments.vue";

export default {
  name: "ProfileMuniTransferDocuments",
  components: { ProfileMunicipalityTransferDocuments },
};
</script>

<style lang="scss" scoped>
.Profile__General__Page {
  padding: 20px 40px;

  .Profile__General__Page__Header {
    border-bottom: 1px solid silver;
    padding: 0px 10px 10px 10px;

    h1 {
      font-size: 30px;
    }
  }

  .Profile__General__Page__Form {
    margin-top: 20px;
  }
}
</style>
